module.exports = require("prismjs/components/prism-go.js");